import { Layout, Menu, Result } from "antd";
import { useNavigate, useParams } from "react-router";

import { useAuthenticated } from "../auth/SessionProvider";
import { MODULE_REGISTRY, moduleById } from "../modules/registry";
import { Brand } from "./Brand";
import { UserBar } from "./UserBar";

/** Inside a module the tiles become the side menu; the header keeps the role and scope visible. */
export function ModuleShell() {
  const { principal } = useAuthenticated();
  const navigate = useNavigate();
  const { module: moduleId = "" } = useParams();
  const allowed = MODULE_REGISTRY.filter((module) => principal.modules.includes(module.id));
  const current = moduleById(moduleId);
  let content;
  if (!current) {
    content = <Result status="404" title="模块不存在" subTitle={`没有名为 ${moduleId} 的功能。`} />;
  } else if (!principal.modules.includes(current.id)) {
    content = <Result status="403" title="无权访问" subTitle="当前角色不能进入该模块。" />;
  } else {
    content = current.element;
  }
  return (
    <Layout className="app-layout">
      <Layout.Header className="app-header">
        <Brand />
        <UserBar />
      </Layout.Header>
      <Layout>
        <Layout.Sider width={220} className="app-sider" theme="light">
          <Menu
            mode="inline"
            selectedKeys={current ? [current.id] : []}
            items={allowed.map((module) => ({ key: module.id, icon: module.icon, label: module.title }))}
            onClick={({ key }) => navigate(`/m/${key}`)}
          />
        </Layout.Sider>
        <Layout.Content className="module-content">{content}</Layout.Content>
      </Layout>
    </Layout>
  );
}
